import { render, staticRenderFns } from "./location-restriction-list.vue?vue&type=template&id=ac75ff96"
import script from "./location-restriction-list.vue?vue&type=script&lang=js"
export * from "./location-restriction-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports